module.exports = __webpack_public_path__ + "static/img/MB-star_n_2D_3Cweb.0a408f3d.svg";